import PreplayScoreboardImpl from './preplay-scoreboard.js';
import MojitoCore from 'mojito/core';
import { getPropTypes } from 'presentation/components/scoreboard/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A View to display a pre-play scoreboard.
 *
 * @class PreplayScoreboard
 * @private
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * `PreplayScoreboard` component properties.
 *
 * @extends Mojito.Presentation.Components.Scoreboard.default.ScoreboardPropTypes
 * @memberof Mojito.Presentation.Components.Scoreboard.PreplayScoreboard
 */
const propTypes = { ...getPropTypes() };

const defaultProps = {
    showEventIndicators: true,
};

export default UIView('PreplayScoreboard', PreplayScoreboardImpl, propTypes, defaultProps);
